import { useEffect, useState } from "react"; 
import { useNavigate } from "react-router";
import '../styles/Unauthorized.css'; // Import your CSS styles
// functional component
function Unauthorized() {

    const countdownSeconds = 10;
    const [countdown, setCountdown] = useState(countdownSeconds);
    const navigate = useNavigate();

    useEffect(() => {
        if(countdown === 0){
            navigate('/login'); // Redirect to your target page
            return;
        }

        const timer = setTimeout(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, navigate]);

    return (
        <div style={{ overflowY: 'auto', height: '100vh' }}>
            <div className="flex flex-col items-center justify-center h-screen">
                <img 
                    src="restricted-600.png" 
                    alt="Session Expired" 
                    className="responsive-image"
                />
                <p className="mt-4 text-lg">
                    Your session has expired. For your security, please log in again to continue.
                </p>
                <p className="mt-4 text-lg">
                    You will be redirected to the login page in <span style={{ color: '#EF4444' }}>{countdown} seconds.</span>
                </p>
            </div>
        </div>
    );
}

export default Unauthorized;